import styles from "./styles.module.scss";
import img1 from "./img/1.png";
import img2 from "./img/2.png";
import img3 from "./img/3.png";
import img4 from "./img/4.png";

import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";
import { WALKY_KEYS } from "src/routes/onboarding/shared/constants/walkyKeys";

const data = [
  {
    value: "Alert and vibrant",
    displayValue: "Alert and vibrant",
    emoji: img1,
  },
  {
    value: "A drop of energy in the afternoon",
    displayValue: "A drop of energy in the afternoon",
    emoji: img2,
  },
  {
    value: "Post meal slump",
    displayValue: "Post meal slump",
    emoji: img3,
  },
  {
    value: "Tired, experiencing fatigue",
    displayValue: "Tired, experiencing fatigue",
    emoji: img4,
  },
];
export const EnergyLevels = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    localStorage.setItem(WALKY_KEYS.energyLevels, v.points);
    onNextStep(v.value);
    onTrackEvent?.(v.displayValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>What about your energy levels?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardWalky
              onClick={() => handleNextStep(value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.points}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
